import { usePlaylist } from '../../savedItems/savedItemsQueries';
import { usePlaylistIdFromSearch } from '../hooks';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { H3 } from 'foundations-components/transitional/components/H3';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useUserInfo } from '../../accounts';
import formatFriendlyName from 'I18n/utils/formatFriendlyName';
import UIRouterButton from 'ui-addon-react-router-dom/UIRouterButton';
import { LearningContentContainer } from '../../learningContent';
import { View } from 'foundations-components/components/View';
import FinishedContainer from '../../../components/FinishedContainer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const PlaylistComplete = () => {
  const playlistId = usePlaylistIdFromSearch();
  const {
    playlist
  } = usePlaylist(playlistId, !playlistId);
  const {
    userInfo
  } = useUserInfo();
  const body = playlist && userInfo && /*#__PURE__*/_jsxs(View, {
    children: [/*#__PURE__*/_jsx(H3, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.playlistContent.completePlaylistContent.completeTitle",
        options: {
          name: formatFriendlyName({
            givenName: userInfo.user.firstName,
            familyName: userInfo.user.lastName
          })
        }
      })
    }), /*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.playlistContent.completePlaylistContent.completeSubtitle"
      })
    })]
  });
  return /*#__PURE__*/_jsx(LearningContentContainer, {
    children: /*#__PURE__*/_jsx(FinishedContainer, {
      body: body,
      footer: /*#__PURE__*/_jsx(UIRouterButton, {
        to: "/",
        use: "secondary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.playlistContent.completePlaylistContent.completeCta"
        })
      }),
      illustration: /*#__PURE__*/_jsx(Illustration, {
        name: "success"
      })
    })
  });
};